import type {ReactAction} from '@netx/core/bootstrap';
import {faDownload} from '@fortawesome/pro-solid-svg-icons';
import {canDownloadSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionDownloadIcon = faDownload;

/**
 * Download saved search assets
 * @param params
 * @returns Action
 */
export const searchSavedActionDownload = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-download',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.DOWNLOAD, savedSearch),
	enableTest: () => canDownloadSavedSearch(savedSearch),
	icon: searchSavedActionDownloadIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.DOWNLOAD;
	},
	...params,
});

export default searchSavedActionDownload;
